import { AvatarIcon, BrightyListItem, StatementIcon } from '@razz-team/ui-web';
import { useTranslation } from 'react-i18next';
import { useDownloadTransactionStatementMutation } from '../../api/transactions';
import { useCallback } from 'react';

export function TransactionStatementListItem({
  transactionId,
  createdAt,
}: {
  transactionId: string;
  createdAt: string;
}) {
  const { t } = useTranslation();
  const mutation = useDownloadTransactionStatementMutation();

  const handleDownload = useCallback(() => {
    mutation.mutate({ createdAt, transactionId });
  }, [createdAt, mutation, transactionId]);

  return (
    <BrightyListItem
      title={t('Statement')}
      icon={<AvatarIcon icon={<StatementIcon />} />}
      error={mutation.error ? t(mutation.error.name, mutation.error.params) : undefined}
      loading={mutation.isPending}
      onClick={handleDownload}
    />
  );
}
